export const GET_ICEPACK_STATE_INFO = 'icepacks-states-modal/GET_ICEPACK_STATE_INFO';
export const getIcepackStateInfoAction = payload => ({
	type: GET_ICEPACK_STATE_INFO,
	payload,
});

export const SET_ICEPACK_STATE_INFO = 'icepacks-states-modal/SET_ICEPACK_STATE_INFO';
export const setIcepackStateInfoAction = payload => ({
	type: SET_ICEPACK_STATE_INFO,
	payload,
});

export const SET_IS_ICEPACK_STATE_INFO_LOADING = 'icepacks-states-modal/SET_IS_ICEPACK_STATE_INFO_LOADING';
export const setIsIcepackStateInfoLoadingAction = payload => ({
	type: SET_IS_ICEPACK_STATE_INFO_LOADING,
	payload,
});

export const CREATE_ICEPACK_STATE = 'icepacks-states-modal/CREATE_ICEPACK_STATE';
export const createIcepackStateAction = payload => ({
	type: CREATE_ICEPACK_STATE,
	payload,
});

export const SET_IS_ICEPACK_STATE_CREATING = 'icepacks-states-modal/SET_IS_ICEPACK_STATE_CREATING';
export const setIsIcepackStateCreatingAction = payload => ({
	type: SET_IS_ICEPACK_STATE_CREATING,
	payload,
});

export const UPDATE_ICEPACK_STATE = 'icepacks-states-modal/UPDATE_ICEPACK_STATE';
export const updateIcepackStateAction = payload => ({
	type: UPDATE_ICEPACK_STATE,
	payload,
});

export const SET_IS_ICEPACK_STATE_UPDATING = 'icepacks-states-modal/SET_IS_ICEPACK_STATE_UPDATING';
export const setIsIcepackStateUpdatingAction = payload => ({
	type: SET_IS_ICEPACK_STATE_UPDATING,
	payload,
});

export const DELETE_ICEPACK_STATE = 'icepacks-states-modal/DELETE_ICEPACK_STATE';
export const deleteIcepackStateAction = payload => ({
	type: DELETE_ICEPACK_STATE,
	payload,
});

export const SET_IS_ICEPACK_STATE_DELETING = 'icepacks-states-modal/SET_IS_ICEPACK_STATE_DELETING';
export const setIsIcepackStateDeletingAction = payload => ({
	type: SET_IS_ICEPACK_STATE_DELETING,
	payload,
});

export const RESET_STATE = 'icepacks-states-modal/RESET_STATE';
export const resetStateAction = () => ({
	type: RESET_STATE,
});
